import {
  AsyncActionState,
  asyncActionStateMatchers,
  invoke,
  setupSlice,
} from '@owl-frontend/redux';
import { fetchSchema } from '../../api/artifacts/client';
import type { SchemaBundle } from '../../api/artifacts/interface';

export interface SchemasState {
  byName: {
    [schema_name: string]: SchemaBundle;
  };
  statusByName: {
    [schema_name: string]: string;
  };
  actions: {
    fetchSchema: AsyncActionState<SchemaBundle>;
  };
}

const initialState: SchemasState = {
  byName: {},
  statusByName: {},
  actions: {
    fetchSchema: { status: 'uninitialized' },
  },
};

const slice = setupSlice('schemas', initialState)
  .addAsyncSagas({
    fetchSchema: invoke(fetchSchema),
  })
  .addReducers({
    'fetchSchema/pending': (state, action) => {
      state.statusByName[action.meta.arg] = 'pending';
    },
    'fetchSchema/fulfilled': (state, action) => {
      state.byName[action.meta.arg] = action.payload;
      state.statusByName[action.meta.arg] = 'fulfilled';
    },
    'fetchSchema/rejected': (state, action) => {
      state.statusByName[action.meta.arg] = 'rejected';
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
